import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';

export const getCountryCodeFromArea = (area: string) => {
  const countryCodeFromArea = area.split('--').pop()?.toUpperCase();
  return (
    (countryCodeFromArea && CountryCodes[countryCodeFromArea as CountryCodes]) || CountryCodes.GB
  );
};
